/* ------------------------------------------------------------------
   Intercepta TODOS os /cart/add.js
   • bloqueia se o estoque estiver zerado (erro 422)
   • guarda, no próprio formulário, “quanto já está no carrinho”
------------------------------------------------------------------ */
document.addEventListener('DOMContentLoaded', () => {

  /* util – troca só o <span> interno do botão, preservando spinner */
  function setBtnLabel (btn, label) {
    const span = btn.querySelector('span');
    if (span)  span.textContent = label;
    else       btn.textContent = label;
  }

  /* 1. Mapeia somente objetos com disponibilidade de variante ----- */
  const variants = {};

  function registerVariant (variant) {
    if (!variant || typeof variant !== 'object') return;
    if (variant.id === undefined || variant.id === null) return;
    if (typeof variant.available !== 'boolean') return;

    variants[variant.id] = variant;
  }

  document.querySelectorAll('script[type="application/json"]').forEach(tag => {
    try {
      const data = JSON.parse(tag.textContent);

      if (data && Array.isArray(data.variants)) {
        data.variants.forEach(registerVariant);
      }

      if (Array.isArray(data)) {
        data.forEach(registerVariant);
      }
    } catch(e) { /* ignora JSON estranho */ }
  });

  /* 2. Percorre todos os forms /cart/add --------------------------- */
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {

    const btn   = form.querySelector('[name="add"], button[type="submit"]');
    const idInp = form.querySelector('input[name="id"]');
    if (!btn || !idInp) return;

    /* ---------- decide o estado do botão ---------- */
    function refresh () {
      const id       = idInp.value.trim();
      const variant  = variants[id];
      const inCart   = parseInt(idInp.dataset.cartQuantity || 0);

      if (!id) {
        btn.disabled = true;
        btn.classList.add('disabled');
        setBtnLabel(btn, 'ADICIONAR AO CARRINHO');
        return;
      }

      if (variant) {
        const hasStockInfo = Number.isFinite(variant.inventory_quantity);
        const estoque      = hasStockInfo ? variant.inventory_quantity : Infinity;
        const restante     = estoque - inCart;

        if (variant.available && restante > 0) {
          btn.disabled = false;
          btn.classList.remove('disabled');
          setBtnLabel(btn, 'ADICIONAR AO CARRINHO');
        } else {
          btn.disabled = true;
          btn.classList.add('disabled');
          setBtnLabel(btn, 'ESGOTADO');
        }
      } else {
        btn.disabled = false;
        btn.classList.remove('disabled');
        setBtnLabel(btn, 'ADICIONAR AO CARRINHO');
      }
    }

    /* primeira verificação + observadores ------------------------- */
    refresh();
    new MutationObserver(refresh)
      .observe(idInp, {attributes:true, attributeFilter:['value']});
    form.addEventListener('change', refresh);

    /* 3. Intercepta o submit (/cart/add.js) ------------------------ */
    form.addEventListener('submit', async ev => {
      ev.preventDefault();

      const fd = new FormData(form);

      try {
        const r = await fetch('/cart/add.js', {
          method : 'POST',
          body   : fd,
          headers: {'X-Requested-With':'XMLHttpRequest'}
        });

        /* 422 = estoque insuficiente ------------------------------ */
        if (!r.ok) {
          btn.disabled = true;
          btn.classList.add('disabled');
          setBtnLabel(btn, 'ESGOTADO');
          return;
        }

        const json    = await r.json();
        const added   = fd.get('quantity') ? parseInt(fd.get('quantity')) : 1;
        const current = parseInt(idInp.dataset.cartQuantity || 0);
        idInp.dataset.cartQuantity = current + added;

        refresh();

        /* abre / actualiza o mini-cart ---------------------------- */
        const drawer = document.querySelector('cart-drawer')
                    || document.querySelector('cart-notification');

        if (drawer && drawer.renderContents) {
          drawer.renderContents(json);
          drawer.classList.remove('is-empty');
          drawer.open && drawer.open();
        } else {
          location.assign('/cart');
        }

      } catch(err) {
        console.error('add-to-cart falhou', err);
      }
    });
  });
});